import { ChainId } from '@fbomb-finance/exchange-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xccbebfF811475aaB6B731211b46a0407d1550A39', // TODO
  [ChainId.TESTNET]: '0x49766ef3EdbD7d1f8A60Cf34eE8820808Ca927B7'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
